import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';
function PlusIconRaw({
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
}) {
  return (
    <Svg width="19" height="19" viewBox="0 0 19 19" fill={fill} style={style}>
      <Path
        d="M1.90625 9.65344H17.3398"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M9.625 1.93799L9.625 17.3716"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  );
}

export const PlusIcon = nativewindWrapSvg(PlusIconRaw);
